export default "__VITE_ASSET__9fbda549__"